// frontend/src/utils/dateUtils.js

/**
 * Formats a date string into a human-readable relative time (e.g., "2 minutes ago", "Yesterday")
 * @param {string|Date} date - The date to format
 * @returns {string} - Human readable relative time
 */
export const formatRelativeTime = (date) => {
    if (!date) return 'Never';
    
    const now = new Date();
    const then = new Date(date);
    const diffInSeconds = Math.floor((now - then) / 1000);
    
    if (diffInSeconds < 60) return 'Just now';
    
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
    
    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) return `${diffInHours}h ago`;
    
    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays === 1) return 'Yesterday';
    if (diffInDays < 7) return `${diffInDays}d ago`;
    
    // Fallback to standard date string for older dates
    return then.toLocaleDateString(undefined, { 
        month: 'short', 
        day: 'numeric', 
        year: then.getFullYear() !== now.getFullYear() ? 'numeric' : undefined 
    });
};
